import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, ControlGroup, Dialog, DialogBody, DialogFooter, FormGroup, HTMLSelect, HTMLTable, InputGroup, OverlayToaster, Position } from '@blueprintjs/core';
import cx from 'classnames';
import Pagination from '../Pagination';
import { useQuery } from 'react-query';
import { queryClient } from '../queryClient';
import { presentDialog } from '../presentDialog';
import { callMethod } from '../callMethod';
import { Header } from '../Header';
import { Loading } from '../Loading';
import copy from 'copy-to-clipboard';
import { UserContext } from '../UserContext';

const states = [{"name":"Alabama","abbreviation":"AL"},{"name":"Alaska","abbreviation":"AK"},{"name":"Arizona","abbreviation":"AZ"},{"name":"Arkansas","abbreviation":"AR"},{"name":"California","abbreviation":"CA"},{"name":"Colorado","abbreviation":"CO"},{"name":"Connecticut","abbreviation":"CT"},{"name":"Delaware","abbreviation":"DE"},{"name":"Florida","abbreviation":"FL"},{"name":"Georgia","abbreviation":"GA"},{"name":"Hawaii","abbreviation":"HI"},{"name":"Idaho","abbreviation":"ID"},{"name":"Illinois","abbreviation":"IL"},{"name":"Indiana","abbreviation":"IN"},{"name":"Iowa","abbreviation":"IA"},{"name":"Kansas","abbreviation":"KS"},{"name":"Kentucky","abbreviation":"KY"},{"name":"Louisiana","abbreviation":"LA"},{"name":"Maine","abbreviation":"ME"},{"name":"Maryland","abbreviation":"MD"},{"name":"Massachusetts","abbreviation":"MA"},{"name":"Michigan","abbreviation":"MI"},{"name":"Minnesota","abbreviation":"MN"},{"name":"Mississippi","abbreviation":"MS"},{"name":"Missouri","abbreviation":"MO"},{"name":"Montana","abbreviation":"MT"},{"name":"Nebraska","abbreviation":"NE"},{"name":"Nevada","abbreviation":"NV"},{"name":"New Hampshire","abbreviation":"NH"},{"name":"New Jersey","abbreviation":"NJ"},{"name":"New Mexico","abbreviation":"NM"},{"name":"New York","abbreviation":"NY"},{"name":"North Carolina","abbreviation":"NC"},{"name":"North Dakota","abbreviation":"ND"},{"name":"Ohio","abbreviation":"OH"},{"name":"Oklahoma","abbreviation":"OK"},{"name":"Oregon","abbreviation":"OR"},{"name":"Pennsylvania","abbreviation":"PA"},{"name":"Rhode Island","abbreviation":"RI"},{"name":"South Carolina","abbreviation":"SC"},{"name":"South Dakota","abbreviation":"SD"},{"name":"Tennessee","abbreviation":"TN"},{"name":"Texas","abbreviation":"TX"},{"name":"Utah","abbreviation":"UT"},{"name":"Vermont","abbreviation":"VT"},{"name":"Virginia","abbreviation":"VA"},{"name":"Washington","abbreviation":"WA"},{"name":"West Virginia","abbreviation":"WV"},{"name":"Wisconsin","abbreviation":"WI"},{"name":"Wyoming","abbreviation":"WY"}]

const AppToaster = OverlayToaster.create({
  className: "recipe-toaster",
  position: Position.TOP,
});

function Copyable(props: { text?: string, children: any }) {
  return <span className="copyable"
    onClick={() => {
      const text = props.text || props.children;
      AppToaster.clear();
      AppToaster.show({ timeout: 1000, message: `"${text}" copied to clipboard`, intent: "success" });
      copy(text);
    }}
  >{props.children}</span>
}

interface CCDialogProps {
  isOpen?: boolean;
  onClose?: any;
  action: 'edit' | 'create';
  card?: Card;
  onSave?: any;
  onClosed?: any;
  onClickDelete?: (confirmed: () => void) => void;
}
function CCDialog(props: CCDialogProps) {
  const [number, setNumber] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [code, setCode] = useState('');
  const [expMonth, setExpMonth] = useState('');
  const [expYear, setExpYear] = useState('');
  const [addressLine1, setAddressLine1] = useState('');
  const [addressLine2, setAddressLine2] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [country, setCountry] = useState('');

  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (props.card?.id) {
      setNumber(props.card.number);
      setFirstName(props.card.firstName);
      setLastName(props.card.lastName);
      setExpMonth(props.card.expMonth);
      setExpYear(props.card.expYear);
      setCode(props.card.code);

      setAddressLine1(props.card.addressLine1);
      setAddressLine2(props.card.addressLine2);
      setCity(props.card.city);
      setState(props.card.state);
      setZipCode(props.card.zipCode);
      setCountry(props.card.country);
    }
  }, []);

  return <Dialog
    onClosed={() => {
      console.log('adsf');
    }}
    className="dialog"
    style={{ width: '400px' }}
    title={`${props.action === 'create' ? 'New' : 'Edit'} Credit Card`}
    isOpen={props.isOpen}
    onClose={props.onClose}
  >
    <DialogBody>
      <FormGroup
        label="Number"
        labelFor="number-input"
      >
        <InputGroup
          defaultValue={number}
          onChange={e => setNumber(e.target.value)}
          id="number-input"
        />
      </FormGroup>
      <ControlGroup>
        <FormGroup
          label="First Name"
        >
          <InputGroup
            defaultValue={firstName}
            onChange={e => setFirstName(e.target.value)}
          />
        </FormGroup>
        <FormGroup
          label="Last Name"
        >
          <InputGroup
            defaultValue={lastName}
            onChange={e => setLastName(e.target.value)}
          />
        </FormGroup>
      </ControlGroup>
      <FormGroup
        label="Code"
        labelFor="code-input"
      >
        <InputGroup
          defaultValue={code}
          onChange={e => setCode(e.target.value)}
          id="code-input"
          placeholder=""
        />
      </FormGroup>
      <ControlGroup fill>
        <FormGroup
          label="Exp Month"
        >
          <HTMLSelect value={expMonth} onChange={e => setExpMonth(e.target.value)}>
            <option />
            <option value="01">1 - January</option>
            <option value="02">2 - February</option>
            <option value="03">3 - March</option>
            <option value="04">4 - April</option>
            <option value="05">5 - May</option>
            <option value="06">6 - June</option>
            <option value="07">7 - July</option>
            <option value="08">8 - August</option>
            <option value="09">9 - September</option>
            <option value="10">10 - October</option>
            <option value="11">11 - November</option>
            <option value="12">12 - December</option>
          </HTMLSelect>

        </FormGroup>
        <FormGroup
          label="Exp Year"
        >
          <InputGroup
            defaultValue={expYear}
            onChange={e => setExpYear(e.target.value)}
          />
        </FormGroup>
      </ControlGroup>
      <FormGroup label="Address Line 1" >
        <InputGroup
          defaultValue={addressLine1}
          onChange={e => setAddressLine1(e.target.value)}
        />
      </FormGroup>
      <FormGroup label="Address Line 2">
        <InputGroup
          defaultValue={addressLine2}
          onChange={e => setAddressLine2(e.target.value)}
        />
      </FormGroup>
      <ControlGroup fill>
        <FormGroup label="City">
          <InputGroup
            defaultValue={city}
            onChange={e => setCity(e.target.value)}
          />
        </FormGroup>
        <FormGroup label="State">
          <HTMLSelect value={state} onChange={e => setState(e.target.value)}>
            <option />
            {states.map(st => <option key={st.abbreviation} value={st.abbreviation}>{st.abbreviation} - {st.name}</option>)}
          </HTMLSelect>
        </FormGroup>
      </ControlGroup>
      <FormGroup label="Zip Code">
        <InputGroup
          defaultValue={zipCode}
          onChange={e => setZipCode(e.target.value)}
        />
      </FormGroup>
    </DialogBody>
    <DialogFooter

    actions={<>
      {props.action === 'edit' && (
        <Button
          disabled={deleting}
          intent="danger"
          text={deleting ? 'Deleting...' : 'Delete'}
          onClick={async () => {
            props.onClickDelete?.(() => setDeleting(true));
          }}
        />
      )}
      <Button
        className="save"
        intent="primary"
        text={saving ? 'Saving...' : (props.action === 'edit' ? 'Update' : 'Save')}
        disabled={saving}
        onClick={() => {
          setSaving(true);
          props.onSave?.(props.card, {
            number,
            firstName,
            lastName,
            expMonth,
            expYear,
            code,
            addressLine1,
            addressLine2,
            city,
            state,
            zipCode,
            country,
          });
        }}
      />
    </>}>
      {props.action == 'edit' && <span className="creation-info">
        {props.card?.userName} at {props.card?.timestamp && (new Date(props.card?.timestamp) as any).format('{yyyy}-{MM}-{dd} {HH}:{mm}')}
      </span>}
    </DialogFooter>
  </Dialog>;
}
interface BaseCard {
  number: string;
  name: string;
  code: string;
  address: string;
}
interface Card {
  id: string;
  number: string;
  firstName: string;
  lastName: string;
  code: string;

  expMonth: string;
  expYear: string;

  userName: string;
  timestamp: number;

  addressLine1: string;
  addressLine2: string;

  city: string;
  state: string;
  zipCode: string;
  country: string;
}
interface QueryParams {
  filter: string;
  page: number;
}

async function getCards(params: QueryParams): Promise<{ cards: Card[]; pages: number; }> {
  return await callMethod('cards.query', params);
}

async function createCard(card: BaseCard) {
  await callMethod('cards.create', card);
}

async function updateCard(id: string, value: BaseCard) {
  await callMethod('cards.update', { id, ...value });
}

async function deleteCard(id: string) {
  await callMethod('cards.delete', { id });
}
interface CardsPageProps {
  onNav?: any;
}
export function CardsPage(props: CardsPageProps) {
  const [filterFocused, setFilterFocused] = useState(false);
  const [filterValue, setFilterValue] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const timerId = useRef<any>();

  const queryParams: QueryParams = {
    filter: filterValue,
    page: currentPage,
  };

  const { data, isLoading, isFetching } = useQuery(['cards', queryParams], () => getCards(queryParams));

  const cards = data?.cards;
  const {user} = useContext(UserContext);

  return (
    <div className="cards-page">
      <Header
        active="cards"
        onNav={props.onNav}
        right={<>
          <InputGroup
            className={cx('filter', {
              focused: filterFocused || filterValue
            })}
            onFocus={() => {
              setFilterFocused(true);
            }}
            onBlur={() => {
              setFilterFocused(false);
            }}
            defaultValue={filterValue}
            onChange={e => {
              clearTimeout(timerId.current);
              timerId.current = setTimeout(() => {
                setCurrentPage(0);
                setFilterValue(e.target.value);
              }, 500);
            }}
            placeholder="Filter..." type="search" />

            <Button icon="time" text="" onClick={() => {
                    const text = `Added by ${user.name} at ${(new Date() as any).format('{yyyy}-{MM}-{dd} {HH}:{mm}')}`;
                    AppToaster.clear();
                    AppToaster.show({ timeout: 1000, message: `"${text}" copied to clipboard`, intent: "success" });
                    copy(text);
              
            }} />
        </>} />

      {isLoading && <Loading />}
      {!isLoading && <>
      
      <HTMLTable className={cx('cards-table', { fetching: isFetching })} bordered striped>
        <thead>
          <tr>
            <th className="number">Number</th>
            <th className="firstName">First Name</th>
            <th className="lastName">Last Name</th>
            <th className="code">Code</th>
            <th className="expMonth">Exp. Month</th>
            <th className="expYear">Exp. Year</th>
            <th className="addressLine1">Address Line 1</th>
            <th className="addressLine2">Address Line 2</th>
            <th className="city">City</th>
            <th className="state">State</th>
            <th className="zipCode">Zip Code</th>
            {/* <th className="user">User</th> */}
            <th className="actions" />
          </tr>
        </thead>
        <tbody>
          {cards?.map?.(card => {
            const del = async (confirmed?:any, close?:any) => {
              if (window.confirm('Are you sure?')) {
                confirmed?.();
                await deleteCard(card.id);
                queryClient.invalidateQueries('cards');
                close?.();
              }
            }
            return (
              <tr key={card.id}>
                <td><Copyable>{card.number}</Copyable></td>
                <td><Copyable>{card.firstName}</Copyable></td>
                <td><Copyable>{card.lastName}</Copyable></td>
                <td><Copyable>{card.code}</Copyable></td>
                <td><Copyable>{card.expMonth}</Copyable></td>
                <td><Copyable>{card.expYear}</Copyable></td>
                
                <td><Copyable>{card.addressLine1}</Copyable></td>
                <td><Copyable>{card.addressLine2}</Copyable></td>
                <td><Copyable>{card.city}</Copyable></td>
                <td><Copyable>{card.state}</Copyable></td>
                <td><Copyable>{card.zipCode}</Copyable></td>
                {/* <td><Copyable text={`${card?.userName} at ${card?.timestamp && (new Date(card?.timestamp) as any).format('{yyyy}-{MM}-{dd} {HH}:{mm}')}`}>{card.userName}</Copyable></td> */}
                <td className="actions">
                  <div className="cont">
                  <Button icon="edit"
                    onClick={() => {
                      presentDialog((props) => {
                        return (
                          <CCDialog
                            isOpen={props.isOpen}
                            action="edit"
                            card={card}
                            onClose={props.close}
                            onClosed={props.onClosed}
                            onSave={async (card: any, values: any) => {
                              await updateCard(card.id, values);
                              queryClient.invalidateQueries('cards');
                              props.close();
                            }}
                            onClickDelete={async (confirmed) => {
                              del(confirmed, props.close);
                            }}
                          />
                        );
                      });
                    }}
                  
                  />
                  <Button icon="trash" intent="danger"
                    onClick={() => {
                      del();
                    }}
                  />
                  </div>
                </td>
              </tr>
            );
          })}


        </tbody>

      </HTMLTable>
        {data && data.pages > 1 && <div className="pagination-cont">
          <Pagination
            current={currentPage + 1}
            totalCount={data!.pages}
            onPaginate={(p: number) => {
              setCurrentPage(p - 1);
            }}
          />
        </div>}</>}


        {/* <button
          onClick={async () => {
fetch('https://u8qhvc3pxb.execute-api.us-east-1.amazonaws.com/prod/submit', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    number: '4539281394013989',
    firstName: 'Theodora',
    lastName: 'McClure',
    code: '726',
    expMonth: '06',
    expYear: '2026',

    addressLine1: '690 Dejon Villages West Aliya',
    addressLine2: '',
    city: 'New York',
    state: 'NY',
    zipCode: '10113',
  })
});
          
          }}
        >Test</button> */}

      <Button className="add-button" icon="add" onClick={() => {
        presentDialog(props => {
          return (
            <CCDialog
              isOpen={props.isOpen}
              action="create"
              onClose={props.close}
              onClosed={props.onClosed}
              onSave={async (card: any, values: any) => {
                await createCard(values);
                queryClient.invalidateQueries('cards');
                props.close();
              }}
            />
          );
        });
      }} />

    </div>
  );
}
